import React from 'react';
import PropTypes from 'prop-types';

const IconSupportTextTwo = props => {
  const color = props.color || '#585858';
  return (
    <svg width={30} height={24} {...props} viewBox="0 0 30 27">
      <path
        stroke={color}
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.4424 5.2496H3C1.48179 5.2496 0.25 6.48139 0.25 7.9996V19.9996C0.25 21.5178 1.48179 22.7496 3 22.7496H5.394C5.72498 22.7496 6.04325 22.8815 6.27767 23.1159L8.81867 25.6569C9.50145 26.3397 10.6088 26.3397 11.2927 25.6576L13.8343 23.1159C14.0688 22.8815 14.387 22.7496 14.718 22.7496H22C23.5182 22.7496 24.75 21.5178 24.75 19.9996V17.75H27.0004C28.5186 17.75 29.7504 16.5182 29.7504 15V3C29.7504 1.48107 28.5189 0.25 27.0004 0.25H10.1924C8.6739 0.25 7.4424 1.48107 7.4424 3V5.2496ZM8.9424 5.2496H22C23.5182 5.2496 24.75 6.48139 24.75 7.9996V16.25H27.0004C27.6902 16.25 28.2504 15.6898 28.2504 15V3C28.2504 2.30962 27.6906 1.75 27.0004 1.75H10.1924C9.50221 1.75 8.9424 2.30962 8.9424 3V5.2496ZM22 6.7496C22.6898 6.7496 23.25 7.30981 23.25 7.9996V19.9996C23.25 20.6894 22.6898 21.2496 22 21.2496H14.718C13.9891 21.2496 13.2893 21.5396 12.7737 22.0553L10.2327 24.5963C10.1352 24.6935 9.97655 24.6935 9.87933 24.5963L7.33833 22.0553C6.82268 21.5396 6.12292 21.2496 5.394 21.2496H3C2.31021 21.2496 1.75 20.6894 1.75 19.9996V7.9996C1.75 7.30981 2.31021 6.7496 3 6.7496H22Z"
      />
    </svg>
  );
};

IconSupportTextTwo.propTypes = {
  color: PropTypes.string,
};

export default IconSupportTextTwo;
